import React, { Component} from 'react';
import { Popover } from 'antd';


class TooltipTA extends Component {

  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
    this.style = {
      width: '100%',
      padding: '8px 16px'
    }
  }

  componentDidMount(){
    setTimeout(function(){
      this.setState({
        visible: true
      });
    }.bind(this), 300)
  }

  closeTT(){
    this.setState({
      visible:false
    });
    this.props.nextLine();
  }

  render() {
    const content = (
      <div
        className='thinkaloud-tooltip'
        onClick={this.closeTT.bind(this)}>
        {this.props.content}
      </div>
    );

    return (
      <Popover
        content={content}
        placement="right"
        visible={this.state.visible}
        overlayClassName="tooltipTA"
        getPopupContainer = {() => document.querySelector('#course-inner')}
      >
          {this.props.children}
      </Popover>
    );
  }

}

export default TooltipTA;



// WEBPACK FOOTER //
// ./src/components/ThinkAloud/TooltipTA.js